import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const ConfettiEffect = () => {
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    // Generate random particles
    const colors = ['#f59e0b', '#ef4444', '#3b82f6', '#10b981', '#8b5cf6', '#ec4899'];
    const newParticles = Array.from({ length: 80 }).map((_, i) => ({
      id: i,
      x: Math.random() * 100, // Random viewport width position
      color: colors[Math.floor(Math.random() * colors.length)],
      size: Math.random() * 12 + 6,
      rotation: Math.random() * 360,
      delay: Math.random() * 3, // Staggered start
      duration: Math.random() * 2 + 2, // Fall speed
      shape: Math.random() > 0.5 ? 'circle' : 'rect'
    }));
    
    setParticles(newParticles);
  }, []);

  return (
    <div className="fixed inset-0 pointer-events-none z-[100] overflow-hidden">
      {particles.map(p => (
        <motion.div
          key={p.id}
          initial={{ x: `${p.x}vw`, y: '-10vh', rotate: p.rotation }}
          animate={{ y: '110vh', rotate: p.rotation + 360 }}
          transition={{ duration: p.duration, delay: p.delay, repeat: Infinity, ease: 'linear' }}
          style={{
            position: 'absolute',
            width: p.size,
            height: p.shape === 'rect' ? p.size * 1.5 : p.size,
            backgroundColor: p.color,
            borderRadius: p.shape === 'circle' ? '50%' : '2px',
            opacity: 0.8
          }}
        />
      ))}
    </div>
  );
};

export default ConfettiEffect;